import { Component, OnInit } from '@angular/core';
import { ProductService } from '../shared/product.service';
import { NgForm } from "@angular/forms";
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ciu-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private productService: ProductService, private _sanitizer: DomSanitizer, private translate: TranslateService ) {
  }
lang;
  isSubscribed = false;
  sentSuccess = false;
  email = '';
  emailInvalid: boolean = false;
  showForm: boolean = false;

  //send email form
  name = '';
  sender = '';
  comment = '';

  ngOnInit() {
    this.productService.getLanguages().subscribe((s) => {
      this.lang = s;

    });
   }

  subscribeNewsleter(form: NgForm) {
    if (form.valid) {
      this.productService.addNewsletter(this.email).subscribe(() => console.log('success'));
      this.isSubscribed = true;
      this.emailInvalid = false;
    } else {
      this.emailInvalid = true;
      setTimeout(() => {
        this.emailInvalid = false;
      }, 4000);
    }
  }

  SenEmail(form: NgForm) {
    if (form.valid) {
      let object = {
        sender: this.sender,
        name: this.name,
        comment: this.comment
      }

      this.productService.sendEmail(object).subscribe(
        s => { },
        e => console.log(e),
        () => {
          this.sentSuccess = true;
          console.log('send succeded');
        })

      this.sentSuccess = true;

    }
  }

  onNavigate(): void {
    if (this.lang === 'de') {
      const content = '/assets/privacy_policy_de.html';
      const mapWin =  window.open(content, '_blank');
      mapWin.onload = () => {
          setTimeout(() => {
              mapWin.document.title = this.translate.instant('POLICY');

          }, 50);
      };
    } else if (this.lang === 'en' || this.lang === 'it') {
      const content = '/assets/privacy_policy_en.html';
      const mapWin =  window.open(content, '_blank');
        mapWin.onload = () => {
            setTimeout(() => {
                mapWin.document.title = this.translate.instant('POLICY');

            }, 50);
        };
    } else if (this.lang === 'fr') {
      const content = '/assets/privacy_policy_fr.html';
      const mapWin =  window.open(content, '_blank');
        mapWin.onload = () => {
            setTimeout(() => {
                mapWin.document.title = this.translate.instant('POLICY');

            }, 50);
        };
    }


        // const content = `${'~assets/privacy_policy_de.html.pdf'}`;
        // const newBlob = new Blob([content], { type: 'application/pdf' });
        // const fileURL = URL.createObjectURL(newBlob);
        // const mapWin = window.open(fileURL , '_blank');


        // mapWin.onload = () => {
        //     setTimeout(() => {
        //         mapWin.document.title = `Abholplan`;

        //     }, 800);
        // };

    }

  getMarginTop() {
    let t = document.querySelector(".htc__product__details");
    // console.log(t);
    if (t && t != null) {
      // return 'margin-top:0 !important;';
      return this._sanitizer.bypassSecurityTrustStyle('margin-top:0 !important');
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/footer/footer.component.ts